import { h, Component } from 'preact';
import React from 'react';
import { isCartPage } from '../helpers'

class CartPageNotice extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showNotice: false,
      closed: false
    };
  }

  componentDidMount() {
    const userSettings = this.props.userSettings;
    const showNotice = userSettings.enable_shopify_discount_code_checkout && isCartPage();

    this.setState({ showNotice: showNotice });
  }

  wrapperStyle() {
    return {
      color: this.props.userSettings.cart_page_notice_color,
      backgroundColor: this.props.userSettings.cart_page_notice_background_color
    }
  }


  css() {
    const customCss = this.props.userSettings.cart_page_notice_css;
    const defaultCss = `
                       .mf-cart-page-notice {
                         position: relative;
                         margin-top: 1rem;
                         margin-bottom: 1rem;
                         padding: 0.5em 0.8em;
                       }
                       .mf-cart-page-notice .close {
                         position: absolute;
                         top: 0.5em;
                         right: 0.8em;
                       }
                       `

    if (!!customCss) {
      return customCss;
    } else {
      return defaultCss;
    }
  }

  noticeText() {
    return this.props.userSettings.cart_page_notice_text || I18n.t("cart_page_notice.text")
  }

  closeNotice() {
    this.setState({ closed: true })
  }

  render(props, state) {
    if (state.showNotice && !state.closed) {
      return (
        <div>
          <style dangerouslySetInnerHTML={{__html:
            this.css()
          }} />

          <div className="mf-cart-page-notice" style={this.wrapperStyle()}>
            <span class="mf-cart-page-notice__text">
              {this.noticeText()}
            </span>
            <span className="close" onClick={() => this.closeNotice()}>×</span>
          </div>
        </div>
      );
    }
  }
}

export default CartPageNotice;
